exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-list-item__content > *[data-v-80a81f34] {\n  flex: none;\n}\n.v-sheet.v-list[data-v-80a81f34]:not(.v-sheet--outlined) {\n  /*margin-left: 60px;*/\n  background-color: #274492 !important;\n}\n.v-list-item__content[data-v-80a81f34] {\n\n  display: block;\n}\n.v-btn__content[data-v-80a81f34] {\n  color: white !important;\n}\n", ""]);

// exports
